import React from 'react';
import { motion } from 'framer-motion';
import { Gift, CheckCircle } from 'lucide-react';
import { scrollToPricing } from './utils';
const bonuses = [{
  id: 1,
  title: 'BONO 1 — Banco de Ejemplos Reales Argentinos',
  desc: 'Facturas, recibos, sueldos, IVA, inflación y empresas reales. Listos para usar en clase.'
}, {
  id: 2,
  title: 'BONO 2 — Clases Salvavidas para Días Caóticos',
  desc: 'Secuencias de 20 minutos listas para aplicar. El Plan B que todo profe necesita.'
}, {
  id: 3,
  title: 'BONO 3 — Evaluaciones Listas + Rúbricas Extra',
  desc: 'Pruebas escritas, trabajos prácticos y rúbricas claras. Menos trabajo el fin de semana.'
}, {
  id: 4,
  title: 'BONO 4 — Mapa Anual de Contenidos',
  desc: 'Todo el año de SIC en una sola hoja. Qué dar, en qué orden y en qué momento.'
}];
export function BonusSection() {
  return <section className="py-10 md:py-16 bg-slate-50 border-y border-slate-200" data-id="element-13">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className="text-center mb-6 md:mb-10" data-id="element-15">
          <div className="inline-block bg-red-600 text-white font-bold px-3 py-0.5 rounded-full text-[10px] mb-2 animate-pulse" data-id="element-16">
            SÓLO POR HOY
          </div>
          <h3 className="text-xl md:text-3xl font-extrabold text-slate-900 flex items-center justify-center gap-2" data-id="element-17">
            <Gift className="text-red-500 shrink-0" size={22} data-id="element-18" />
            <span data-id="element-19">GRATIS — Bonos Exclusivos</span>
          </h3>
        </div>

        <div className="grid grid-cols-2 gap-2.5 md:gap-5 mb-6 md:mb-8" data-id="element-20">
          {bonuses.map((bonus, index) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.04
        }} className="bg-white rounded-lg p-3 md:p-5 border border-red-100 relative" data-id="element-21">
              <div className="absolute top-2 right-2 bg-green-100 text-green-700 text-[8px] md:text-[10px] font-bold px-1.5 py-px rounded-full flex items-center gap-0.5" data-id="element-22">
                <CheckCircle size={8} data-id="element-23" /> INCLUIDO
              </div>
              <h4 className="text-xs md:text-sm font-bold text-[#1a365d] mb-1 pr-14 leading-tight" data-id="element-24">
                {bonus.title}
              </h4>
              <p className="text-slate-500 text-[10px] md:text-xs leading-snug" data-id="element-25">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="text-center space-y-2" data-id="element-26">
          <p className="text-sm text-slate-400 line-through" data-id="element-27">
            Valor total de los 4 bonos: $29.990
          </p>
          <p className="text-xl md:text-2xl font-extrabold text-red-600" data-id="element-28">
            Por el día de hoy → GRATIS
          </p>
          <button onClick={scrollToPricing} className="mt-2 w-full sm:w-auto bg-[#d4a017] hover:bg-[#b88a14] text-slate-900 font-bold text-base px-8 py-3.5 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-0.5 inline-flex items-center justify-center gap-2" data-id="element-29">
            👉 Quiero el pack completo + los bonos
          </button>
        </div>
      </div>
    </section>;
}